var exports = {
  "k": "xa15a2ab7--6be3f7--container",
};

module.exports = exports;
